import { useEffect, useRef, useState } from "react";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";

const maskFor = ({ start, end }) => { const m = `linear-gradient(to right, ${start ? "black" : "transparent"} 0, black 48px, black calc(100% - 88px), ${end ? "black" : "transparent"} 100%)`; return { WebkitMaskImage: m, maskImage: m }; };

export default function ScrollRow({ children, className = "", fade = "from-card", testid, mx = "-mx-5 sm:-mx-6", px = "px-5 scroll-px-5 sm:px-6 sm:scroll-px-6" }) {
  const ref = useRef(null);
  const [edge, setEdge] = useState({ start: true, end: true });
  const track = () => {
    const el = ref.current;
    if (el) setEdge({ start: el.scrollLeft < 6, end: el.scrollLeft + el.clientWidth >= el.scrollWidth - 6 });
  };
  useEffect(() => {
    track();
    const ro = new ResizeObserver(track);
    if (ref.current) ro.observe(ref.current);
    return () => ro.disconnect();
  }, []);
  const go = (dir) => ref.current?.scrollBy({ left: dir * ref.current.clientWidth * 0.75, behavior: "smooth" });
  const btn = (dir, Icon, hidden, id) => (
    <button type="button" onClick={() => go(dir)} aria-label={dir > 0 ? "Scroll right" : "Scroll left"} data-testid={testid ? `${testid}-${id}` : undefined} tabIndex={hidden ? -1 : 0}
      className={`absolute top-1/2 -translate-y-1/2 ${dir > 0 ? "right-2" : "left-2"} z-10 h-9 w-9 rounded-full bg-background/90 backdrop-blur-md shadow-[0_4px_14px_-4px_rgba(0,0,0,0.3)] flex items-center justify-center transition-[opacity,transform] active:scale-90 ${hidden ? "opacity-0 pointer-events-none" : "opacity-100"}`}>
      <Icon weight="bold" className="h-4 w-4" />
    </button>
  );
  return (
    <div className={`relative ${mx}`}>
      <div ref={ref} onScroll={track} className={`${px} flex overflow-x-auto no-scrollbar snap-x ${className}`} data-testid={testid} style={fade === "mask" ? maskFor(edge) : undefined}>{children}</div>
      {fade !== "mask" && <>
      <div className={`pointer-events-none absolute inset-y-0 left-0 w-12 bg-gradient-to-r ${fade} to-transparent transition-opacity duration-300 ${edge.start ? "opacity-0" : "opacity-100"}`} />
      <div className={`pointer-events-none absolute inset-y-0 right-0 w-20 bg-gradient-to-l ${fade} to-transparent transition-opacity duration-300 ${edge.end ? "opacity-0" : "opacity-100"}`} data-testid={testid ? `${testid}-fade` : undefined} />
      </>}
      {btn(-1, CaretLeft, edge.start, "prev")}
      {btn(1, CaretRight, edge.end, "next")}
    </div>
  );
}
